import {Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-form-outline[outlineItems][outlineItemIndex]',
    templateUrl: './form-outline.component.html',
    styleUrls: ['./form-outline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormOutlineComponent implements OnInit {

  @Input() outlineItems: string[];
  @Input() outlineItemIndex: number;
  @ViewChild('highlight') highlight!: ElementRef;

  constructor() { }

  ngOnInit(): void {
  }

  updateHighlightPosition(): void {
    const highlightElement = this.highlight?.nativeElement;
    if (!highlightElement && !highlightElement.parentElement) {
      setTimeout(() => {
        this.updateHighlightPosition(); // HACK! Dom isn't ready, try again in 50 ms
      }, 50);
      return;
    }

    const selectedItem = document.querySelector(`.item-${this.outlineItemIndex}`);
    if (!selectedItem) { return; }
    const rect = selectedItem.getBoundingClientRect();
    const parentRect = highlightElement.parentElement.getBoundingClientRect();

    highlightElement.style.top = `${rect.top - parentRect.top}px`;
    highlightElement.style.height = `${rect.height}px`;
  }
}
